module.exports = __webpack_public_path__ + "static/media/progress_bestaetigung.baab8597.svg";